export const ASSIGNEE = 'assignee'
export const CHANGE_ASSGINEE = 'change_assignee'
export const ASSGINEE_ACCOUNT = 'assignee_account'
export const DEALER_LISTING_ASSIGNEE = 'DEALER_LISTING_ASSIGNEE'
export const REASSIGN_DEALER_MANAGER = 'REASSIGN_DEALER_MANAGER'